export enum QUOTE_PAGE_SIDEBAR {
  INCLUDED_PRODUCTS = 'included-products',
  INCLUDED_ENTITLEMENTS = 'included-entitlements',
}

export const NULL_CLOUD_SITE = 'Other';

export const NEW_CLOUD_SITE = 'New site';

export const NEW_ORG = 'New organization';
